<i class="fas fa-map-marker-alt pin-icon"></i>
<ng-content>

</ng-content>